<template>
	<div class="w-100">
		<input
			type="text"
			class="form-control"
			:id="id"
			:value="value"
			placeholder="e.g. cm_2026_10_county_wave4"
			autocomplete="off"
			spellcheck="false"
			@input="$emit('input', $event.target.value)"
			@blur="normalize"
		/>
		<small class="form-text text-muted">
			Optional. Lowercase with underscores, same as the UTM builder. The marketing tracker uses it to match this mail to its campaign.
			<template v-if="purl">Also added to unique URL / QR links as <code>&amp;utm_campaign=</code>.</template>
		</small>
	</div>
</template>

<script>
import { normalizeUtmCampaign } from '@/utils/utm'

export default {
	name: 'UtmCampaignInput',
	props: {
		value: { type: String, default: '' },
		id: { type: String, default: null },
		// Auto campaigns: the value is also appended to the unique URLs (PURL / QR)
		purl: { type: Boolean, default: false },
	},
	methods: {
		normalize() {
			const normalized = normalizeUtmCampaign(this.value) || ''
			if (normalized !== (this.value || '')) this.$emit('input', normalized)
		},
	},
}
</script>
